export const AUDIT_LOG_BANNER_EVENT_NAME = 'hideAuditLogBanner';
